module.exports = __webpack_public_path__ + "img/send.aea769d5.svg";